import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import StoreIcon from '@mui/icons-material/Store';
import ListItem from '@mui/material/ListItem';
import { AccountCircleOutlined } from '@mui/icons-material';
import { Badge, capitalize, Dialog, FormControl, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate, useOutlet } from "react-router-dom";
import { useAuth } from '../hooks/useAuth';

import Button from '@mui/material/Button';
import { BarChart, Dashboard, PowerSettingsNew, Public, RestaurantMenu, Settings, ShoppingCart, ViewQuilt, Inventory } from '@mui/icons-material';
import { ListDrawerItem } from './ListDrawerItem';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { CheckoutForm, Return } from '../modal/Paymentdialog';
import { getStoreConfig } from '../hooks/apiHandler';
import { getRegion } from '../hooks/commanFunc';
import { PayTest, ReturnInPayment } from '../temp/paytest';
import { Timer as TimerIcon } from "@mui/icons-material";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

const drawerWidth = 240;





const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export const MiniDrawer = () => {
  const [openPayDialog, setPayDialog] = useState({ mode: false, view: '' });
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('lg');
  const [sstore, setStore] = useLocalStorage('ds', 'loading');

  const { user, Logout, listStore, updateStoreList } = useAuth();
  const [da, setda] = useLocalStorage('da', null);
  // const [daSu, setdaSu] = useLocalStorage('daSu', null);
  const [activeStore, setActiveStore] = useState({
    storeid: "0",
    name: "",
    address: "",
    type: 2,
    sT: 0,
    sP: 1
  });

  const [open, setOpen] = useState(true);

  const theme = useTheme();
  const isSmallerThanXL = useMediaQuery(theme.breakpoints.down('xl'));
  const outlet = useOutlet();
  const ptlocation = useLocation();
  const navigate = useNavigate();
  const [baseRoute, setBasePath] = useState();
  const globalRegin = getRegion();

  useEffect(() => {
    console.log(globalRegin);
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');
    const pathname = ptlocation.pathname

    setBasePath(capitalize(pathname.split('/')[1])); // 👉 "admin

    if (sessionId) {
      setMaxWidth('sm');
      setFullWidth(false);
      setPayDialog({
        mode: true,
        view: 'return'
      });

    }

    updateStoreList();
    if (isSmallerThanXL) {
      setOpen(false);
    }
    if (da === 2) {
      navigate("/admin/user", { replace: true });
    }


    async function callStoreConfig() {
      var response = await getStoreConfig({ storeID: sstore }, Logout);
      if (response) {
        // console.log(response);
        if (response.code === 32) {
          setPayDialog({ mode: true, view: 'checkout' });
        } else {
          // this is Comming Soon to Handle the reactivation and all...
        }
      }
    }
    if (da < 2) {
      callStoreConfig()
    } else {
      console.log('no Need to Check For Employee')
    }

    return () => {

    }
    // eslint-disable-next-line
  }, [isSmallerThanXL, user, sstore]);


  useEffect(() => {
    const foundStore = listStore.find(store => store.storeid === sstore);
    if (foundStore) {
      setActiveStore(foundStore)
    }

    return () => {
    }
  }, [listStore])


  const handleStoreChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === '-1') {
      setda(-1);
      // setdaSu(-1);
      setStore('loading');
      navigate("/store", { replace: true })
    } else {
      const foundStore = listStore.find(store => store.storeid === selectedValue);
      if (foundStore) {
        console.log('Store Found:', foundStore);
        setStore(foundStore.storeid);
        setda(foundStore.type);
        setActiveStore(foundStore);
      }
      if (da >= 0) {
        navigate("/admin", { replace: true });
      } else if (!da || (da === -1)) {
        navigate("/store", { replace: true });
      }
    }
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              {baseRoute}
            </Typography>
            {/* Enter here code for store select and notification... */}
            <Box sx={{ flexGrow: 1 }} />
            <Box key={'m-store'} sx={{ display: 'flex' }}>
              <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                <Select
                  variant="outlined"
                  style={{ backgroundColor: 'whitesmoke', width: '100%' }}
                  autoWidth
                  value={sstore}
                  onChange={handleStoreChange}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {
                    listStore.length > 0 ? (
                      [
                        ...listStore.map((store) => (
                          <MenuItem key={'dd-' + store.storeid} value={store.storeid}>
                            <StoreIcon sx={{ mr: 1 }} fontSize="small" />
                            {store.type} - {store.name}
                          </MenuItem>
                        )),
                        <Divider key="mindrstr-1" />,
                        <MenuItem key="dd-default" value="-1">
                          <StoreIcon sx={{ mr: 1 }} fontSize="small" />
                          All Stores.
                        </MenuItem>
                      ]
                    ) : (
                      <MenuItem key="dd-loading" value="loading" disabled>
                        Loading...
                      </MenuItem>
                    )
                  }
                </Select>
              </FormControl>
            </Box>
            <Box key={'m-not'} sx={{ display: 'flex' }} >
              <MenuItem>
                <IconButton
                  size="large"
                  aria-label="Notifications"
                  color="inherit"
                >
                  <Badge badgeContent={0} color="error" >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
              </MenuItem>
              {/* User Icon */}
              {/* <IconButton sx={{ p: 0 }}>
                <Avatar alt="User Name" src="/logo192.png" />
              </IconButton> */}
            </Box>

          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider key={'mindr-1'} />


          <List>

            {/* // this is the list for admin and Manager */}{(da <= 1) ? (
              <>
                <ListDrawerItem title={'Dashboard'} action={"/admin/"} icon={<Dashboard />} mode={open} />
                <ListDrawerItem title={'Orders'} action={"/admin/order"} icon={<ShoppingCart />} mode={open} />
                <ListDrawerItem title={'Reports'} action={"/admin/reports"} icon={<BarChart />} mode={open} />
                {/* Following List is for Admin add to View only for admin */}
                <ListDrawerItem title={'Time Punch'} action={"/admin/time-punch"} icon={<TimerIcon />} mode={open} />
                <ListDrawerItem title={'Menu'} action={"/admin/menu"} icon={<RestaurantMenu />} mode={open} />
                <ListDrawerItem title={'Side-Cars'} action={"/admin/side-car"} icon={<PlaylistAddIcon />} mode={open} />
                {
                  (activeStore.sP > 0) ? (<ListDrawerItem title={'Inventory'} action={"/admin/inventory"} icon={<Inventory />} mode={open} />) : null
                }

                {/* Also Folloing List is for Advance */}
                {/* <ListDrawerItem title={'Reservation'} subtitle='Comming Soon..' action={"/admin/reservation"} icon={<Event />} mode={open} disable={true} /> */}
                {(da < 1) ? (
                  <>{
                    (activeStore.sT === 1) ? (<ListDrawerItem title={'Layout'} action={"/admin/layout"} icon={<ViewQuilt />} mode={open} />) : null
                  }
                    <ListDrawerItem title={'Online'} action={"/admin/online"} icon={<Public />} mode={open} />
                  </>) : null}

                <Divider key={'mindr-2'} />
              </>) : null}

            {(da < 1) ? (
              <>
                <ListDrawerItem title={'Settings'} action={"/admin/settings"} icon={<Settings />} mode={open} />
                {/* // Following is for Payment Activation Check. this is for trouble store for Now... */}
                {/* <ListItem key={'payli-'} disablePadding sx={{ display: 'block' }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                    }}
                    onClick={() => {
                      console.log('Open Model to...');
                      setPayDialog({ mode: true, view: 'checkout' });
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <CurrencyExchange />
                    </ListItemIcon>
                    <ListItemText primary={'Activate Store'} secondary={'Pay to active Store and resume your Operations'} sx={{ opacity: open ? 1 : 0 }} />
                  </ListItemButton>
                </ListItem> */}
              </>
            ) : null}


            {/* For the following pay option check the subseprition */}

            {/* Following is for temporary... */}
            {/* <ListDrawerItem title={'create Order'} action={"/admin/create"} icon={<Create />} mode={open} /> */}
          </List>
          <Box sx={{ flexGrow: 1, flexDirection: 'row', }}></Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            mb: 2
          }}>
            <List>
              <ListDrawerItem title={'Profile'} action={"/admin/user"} icon={<AccountCircleOutlined />} mode={open} />
              <ListItem key={'Logout-0'} onClick={() => Logout()} disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <PowerSettingsNew color="error" />
                  </ListItemIcon>
                  <ListItemText primary={<Button variant="outlined" color="error" >
                    Logout
                  </Button>} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Drawer>
        {/* Padding for every screen */}
        <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
          <DrawerHeader />
          {outlet}
          <Dialog open={openPayDialog.mode}
            onClose={() => {
              setPayDialog({ mode: false, view: '' })
              navigate("/login", { replace: true });
              return;
            }}
            fullWidth={fullWidth}
            maxWidth={(globalRegin === "India") ? 'sm' : maxWidth}>
            <div style={{ alignSelf: 'end', marginRight: 15 }}>
              <IconButton onClick={() => {
                setPayDialog({ mode: false, view: '' })
                return;
              }}>
                X
              </IconButton>
            </div>
            <div style={{ marginBottom: 15 }} >
              {
                (openPayDialog.view === 'checkout') ?
                  (globalRegin === "India") ? // move to developer mode for testing need to move to India for production // need to triger canada view for testing in developer mode
                    <PayTest onCloseTrigger={(sessionid) => {
                      console.log(sessionid);
                      console.log('Return Function Payment Status Page');
                      setPayDialog({
                        mode: true,
                        view: 'return'
                      });

                    }} />
                    :
                    <CheckoutForm />
                  : (globalRegin === "India") ? /// move to developer mode for testing
                    <ReturnInPayment onCloseTrigger={() => {
                      console.log('Return Function is called');
                      navigate("/admin", { replace: true });
                      setPayDialog({ mode: false, view: '' })
                      // navigate("/login", { replace: true });

                    }} /> :
                    <Return onCloseTrigger={() => {
                      console.log('Return Function is called');
                      navigate("/admin", { replace: true });
                      setPayDialog({ mode: false, view: '' })
                    }} />
              }
            </div>
          </Dialog>
        </Box>
      </Box>
    </div >
  );
}
